












import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../mixins";

@Component({})
export default class TimePicker extends Mixins(ModelEditableMixin) {
  @Prop({ default: false })
  isClearable: boolean;
}
